import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-detail',
  templateUrl: './update-detail.component.html',
  styleUrls: ['./update-detail.component.css']
})
export class UpdateDetailComponent implements OnInit {
  formGroup: UntypedFormGroup;
  userId:any;
  isEditable:boolean=false;

  constructor(private formBuilder: UntypedFormBuilder, private auth: AuthService, private activatedRoute: ActivatedRoute, private router: Router, private toastr: ToastrService) { }
  
  private createFormGroup(): FormGroup {
    return new FormGroup({
      'FormName': new FormControl(''),
      'isEmailExist': new FormControl(true),
      'emailIds': new FormControl(''),
      'successMailMsg': new FormControl(''),
      'onScreenMsg': new FormControl('')
    })
  }
  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
          _id:[''],
          clientName: ['', Validators.required],          
          sendEmail: [false],         
          defaultCountry: [''],
          mailLogo: [''],
          mailName: [''],
          mailEmail: ['', [
              Validators.required,
              Validators.pattern(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
          ]],
          captchaEnabled: [false],
          captchaKey: [''],
          smtpHostName: [''],
          smtpUserName: [''],
          smtpUserPassword: [''],
          smtpUserPort: [''],
          clientForms: this.formBuilder.array([
      ]),
    });
    this.activatedRoute.params.subscribe(params => {
      this.userId = params['id'];
      if (this.userId) {
        this.getProjectById(this.userId);
        this.addRow();
      }
    });
  }
  sendEmailIsEnabled(){
    return this.formGroup.controls['sendEmail'].value;
  }
  sendCaptchaIsEnabled(){
    return this.formGroup.controls['captchaEnabled'].value;
  }
  addRow() {
    let rows = this.formGroup.get('clientForms') as FormArray;
    rows.push(this.createFormGroup());
  }
  removeRow(rowIndex: any) {
    let rows = this.formGroup.get('clientForms') as FormArray;
    if (rows.length > 1) {
      rows.removeAt(rowIndex)
    } else {
      rows.reset()
    }
  }
  getProjectById(id:any){
    this.auth.getProjectById(id).subscribe((res:any)=>{
      for(var i=1;i<res.clientForms.length;i++)
        this.addRow();

      this.formGroup.patchValue(res);
      this.isEditable = true;
    },(err:any)=>{
      console.log(err);
    })
  }

   onSubmit() {
    if(this.formGroup.controls['_id'].value != '' &&  this.formGroup.controls['_id'].value != null)
    {
      this.auth.editClient(this.formGroup.value, this.formGroup.controls['_id'].value).subscribe((res:any)=>{
        this.formGroup.reset();
        this.toastr.success(res.message);
        this.router.navigateByUrl('/clientList');
      },(err:any)=>{
        console.log(err);
        this.toastr.error(err.message);
      })
    }
  }

}
